module.exports = __webpack_public_path__ + "media/customizations/tradition/logo-794c4e52407f5b25c7c6660fcfd37a16.png";